import React from 'react';
import { stats } from '../../data/content';
export function Stats() {
  return <section className="w-full bg-navy px-4 py-12 sm:px-6 sm:py-14" aria-labelledby="stats-title" data-id="element-303" data-mp="2fgggcrp3dspg">
      <div className="mx-auto max-w-5xl" data-id="element-304" data-mp="2agu2qh5cqag4">
        <h2 id="stats-title" className="text-center text-[12px] font-extrabold uppercase leading-relaxed tracking-[0.12em] text-rose-light sm:text-[13px]" data-id="element-305" data-mp="2ahwu0q6l6ewk">
          Join thousands of physicians using structured menopause decision tools
        </h2>

        <dl className="mt-8 grid grid-cols-2 gap-x-4 gap-y-8 lg:grid-cols-4" data-id="element-306" data-mp="2y6g1x4lq4po4">
          {stats.map(stat => <div key={stat.label} className="flex flex-col items-center text-center" data-id="element-307" data-mp="2u3rqcp5ml4ng">
              <dt className="order-2 mt-2 text-[11.5px] font-semibold uppercase leading-snug tracking-wide text-white/65 sm:text-xs" data-id="element-308" data-mp="2p4yc2uiil9m8">
                {stat.label}
              </dt>
              <dd className="order-1 font-display text-[34px] font-bold leading-none text-white sm:text-5xl" data-id="element-309" data-mp="1dqbe7bj42xm5">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}